import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { auth, firestore } from "../firebase";

function Login() {
  // { onLoginSuccess }
  const navigate = useNavigate(); // Initialize useNavigate
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        // const user = userCredential.user;
        navigate("/");
        window.location.reload();
      })
      .catch((error) => {
        // const errorMessage = error.message;
        setLoginError(error.code);
      });
    setEmail("");
    setPassword("");
  };

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();

      const result = await signInWithPopup(auth, provider);

      const user = result.user;

      // Check if the user's email exists in the Firestore "users" collection
      const userDocRef = doc(firestore, "users", user.uid);
      const userDocSnapshot = await getDoc(userDocRef);

      if (!userDocSnapshot.exists()) {
        // Create a new document in the "users" collection with the user's info
        await setDoc(userDocRef, {
          email: user.email,
          name: user.displayName || "",
          isAdmin: false,
        });
      }

      // After successful sign-in, you can navigate or perform other actions
      navigate("/"); // Replace this with your desired navigation logic
    } catch (error) {
      console.error("Google sign-in error:", error);
    }
  };

  return (
    <main id="login">
      <div className="bg"></div>
      <div className="inner flex column justify-center align-center">
        <div className="form">
          <h2>Log In</h2>
          {loginError && <p className="error-message">${loginError}</p>}
          <form onSubmit={handleLogin}>
            <input
              type="email"
              placeholder="Your Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Your Password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button className="button button-primary" type="submit">
              Log In
            </button>
          </form>
          <div className="auth">
            <p>Continue with google</p>
            <button className="button" onClick={handleGoogleLogin}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="64"
                height="64"
                viewBox="0 0 32 32"
              >
                <defs>
                  <path
                    id="A"
                    d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
                  ></path>
                </defs>
                <clipPath id="B">
                  <use xlinkHref="#A"></use>
                </clipPath>
                <path
                  fill="#fbbc05"
                  d="M0 37V11l17 13z"
                  clipPath="url(#B)"
                  transform="matrix(.72727 0 0 .72727 -.955 -1.455)"
                ></path>
                <path
                  fill="#ea4335"
                  d="M0 11l17 13 7-6.1L48 14V0H0z"
                  clipPath="url(#B)"
                  transform="matrix(.72727 0 0 .72727 -.955 -1.455)"
                ></path>
                <path
                  fill="#34a853"
                  d="M0 37l30-23 7.9 1L48 0v48H0z"
                  clipPath="url(#B)"
                  transform="matrix(.72727 0 0 .72727 -.955 -1.455)"
                ></path>
                <path
                  fill="#4285f4"
                  d="M48 48L17 24l-4-3 35-10z"
                  clipPath="url(#B)"
                  transform="matrix(.72727 0 0 .72727 -.955 -1.455)"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Login;
